import EntryActionTypes from '../constants/EntryActionTypes';

const fetchEmployeePlansInCurrentBoard = () => ({
  type: EntryActionTypes.EMPLOYEE_PLANS_IN_CURRENT_BOARD_FETCH,
  payload: {},
});

const createEmployeePlanInCurrentBoard = (data = {}) => ({
  type: EntryActionTypes.EMPLOYEE_PLAN_IN_CURRENT_BOARD_CREATE,
  payload: { data },
});

const updateEmployeePlan = (id, data) => ({
  type: EntryActionTypes.EMPLOYEE_PLAN_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteEmployeePlan = (id) => ({
  type: EntryActionTypes.EMPLOYEE_PLAN_DELETE,
  payload: {
    id,
  },
});

export default {
  fetchEmployeePlansInCurrentBoard,
  createEmployeePlanInCurrentBoard,
  updateEmployeePlan,
  deleteEmployeePlan,
};

